export const USER_CAPABILITY_GRANT_PERMISSIONS = 'USER_CAPABILITY_GRANT_PERMISSIONS';
export const USER_CAPABILITY_REVOKE_PERMISSIONS = 'USER_CAPABILITY_REVOKE_PERMISSIONS';
export const USER_CAPABILITY_DELETE_OPTIONS = 'USER_CAPABILITY_DELETE_OPTIONS';
export const USER_CAPABILITY_EDIT_OPTIONS = 'USER_CAPABILITY_EDIT_OPTIONS';
export const USER_CAPABILITY_CREATE_OPTIONS = 'USER_CAPABILITY_CREATE_OPTIONS';
export const USER_CAPABILITY_MOVE_OPTION = 'USER_CAPABILITY_MOVE_OPTION';
export const MAX_RESULTS_FIELD_EDITOR_FIELDS = 10;
export const UNKNOWN_USER_DISPLAYNAME_PLACEHOLDER_DTO = '___UNKNOWN_USER___';
export const UNKNOWN_GROUP_GROUPNAME_PLACEHOLDER_DTO = '___UNKNOWN_GROUP___';
export var ResolverEntryPoint;
(function (ResolverEntryPoint) {
    ResolverEntryPoint["FIELD_EDITOR"] = "ce-field-editor";
    ResolverEntryPoint["PERMISSION_EDITOR"] = "ce-permission-editor";
})(ResolverEntryPoint || (ResolverEntryPoint = {}));
export const ERROR_MESSAGE_INVALID_CUSTOMFIELD_ID = 'Invalid customfield id.';
export const ERROR_MESSAGE_INVALID_CONTEXT_ID = 'Invalid context id.';
export const returnErrorWithEmptyPayload = (errorAndPayload) => {
    return {
        hasError: errorAndPayload.hasError,
        statusCode: errorAndPayload.statusCode,
        errorMessage: errorAndPayload.errorMessage,
        errorId: errorAndPayload.errorId,
        payload: {},
    };
};
export const returnError400WithEmptyPayload = (errorMessage, errorId) => {
    return {
        hasError: true,
        statusCode: 400,
        errorMessage: errorMessage,
        errorId: errorId,
        payload: {},
    };
};
export const returnNoErrorWithPayload = (payload) => {
    return {
        hasError: false,
        statusCode: 200,
        errorMessage: null,
        errorId: null,
        payload: payload,
    };
};
export const EMPTY_ERROR_OR_PAYLOAD_PAGINATED_REST_CONTEXTS = {
    hasError: false,
    statusCode: 200,
    errorMessage: null,
    errorId: null,
    payload: {
        maxResults: 20,
        startAt: 0,
        total: 0,
        isLast: true,
        values: [],
    },
};
export const EMPTY_RestPaginatedValues = {
    hasError: false,
    statusCode: 200,
    errorMessage: null,
    errorId: null,
    payload: {
        maxResults: 10,
        startAt: 0,
        total: 0,
        isLast: true,
        values: [],
    },
};
export class DTOCustomField {
    fieldId;
    fieldName;
    fieldType;
    fieldDescription;
    fieldGlobalPermission;
    fieldIsLocked;
    fieldIsCompatible;
    constructor(fieldId, fieldName, fieldType, fieldDescription, fieldGlobalPermission, fieldIsLocked, fieldIsCompatible) {
        this.fieldId = fieldId;
        this.fieldName = fieldName;
        this.fieldType = fieldType;
        this.fieldDescription = fieldDescription;
        this.fieldGlobalPermission = fieldGlobalPermission;
        this.fieldIsLocked = fieldIsLocked;
        this.fieldIsCompatible = fieldIsCompatible;
    }
}
export const EMPTY_DTO_PAGINATED_CONTEXTS = {
    maxResults: 20,
    startAt: 0,
    total: 0,
    isLast: true,
    processingTimeInMs: 0,
    values: [],
};
//
// STORAGE DTO
//
export var StoragePermissionDTOUpdateType;
(function (StoragePermissionDTOUpdateType) {
    StoragePermissionDTOUpdateType["ADD"] = "ADD";
    StoragePermissionDTOUpdateType["DELETE"] = "DELETE";
})(StoragePermissionDTOUpdateType || (StoragePermissionDTOUpdateType = {}));
export var StoragePermissionDTOUserOrGroup;
(function (StoragePermissionDTOUserOrGroup) {
    StoragePermissionDTOUserOrGroup["USER"] = "USER";
    StoragePermissionDTOUserOrGroup["GROUP"] = "GROUP";
})(StoragePermissionDTOUserOrGroup || (StoragePermissionDTOUserOrGroup = {}));
